import { inject } from '@angular/core';
import { NavController } from '@ionic/angular';

/**
 * Makes the guarded page the only page in the Ionic stack, however it was
 * reached. For gate pages (invitation, share-data, consent) that the user must
 * not be able to leave by going back into the flow that preceded them.
 *
 * Those pages are only reached through a guard redirect, and a redirect loses
 * the direction of the original navigation: Ionic resets it on the
 * NavigationCancel the redirect emits, so a `navigateRoot([Route.Home])` that
 * gets redirected here would be pushed onto the stack instead, leaving a back
 * button to the previous step. This guard runs within the redirected
 * navigation, after that reset, and re-applies `root`.
 *
 * If another guard on the route rejects or redirects, that cancellation resets
 * the direction again, so this never leaks into a navigation elsewhere.
 */
export const rootNavigationGuard = (): boolean => {
  inject(NavController).setDirection('root');
  return true;
};
